"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = __importDefault(require("./styles"));
const styles_2 = require("@material-ui/core/styles");
const lab_1 = require("@material-ui/lab");
const core_1 = require("@material-ui/core");
const checkboxUnchecked_1 = __importDefault(require("../../../../svgIcons/checkboxUnchecked"));
require("./checkboxList.scss");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const CheckboxList = (props) => {
    const { classes, data, handleChangeEvent, filterType, filterData } = props;
    const updatedFilter = cloneDeep_1.default(Object.assign(Object.assign({}, filterData), { offset: 0 }));
    const List = data.map((el, i) => {
        const selected = !!filterData[filterType].find(f => {
            return f == el.key;
        });
        const item = (react_1.default.createElement("div", { className: classes.labelContainer },
            react_1.default.createElement("div", null,
                react_1.default.createElement(core_1.Checkbox, { disableRipple: true, value: el.key, checked: selected, id: filterType == 'payment_statuses' ? `payment-${i}` : `${i}`, className: classes.checkbox, icon: react_1.default.createElement(checkboxUnchecked_1.default, null), checkedIcon: (selected) ? react_1.default.createElement("span", { className: classes.checkedIcon }) : react_1.default.createElement(checkboxUnchecked_1.default, null) })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: filterType == 'payment_statuses' ? `payment-${i}` : `${i}`, className: classes.childLabelText }, el.value))));
        return react_1.default.createElement(lab_1.TreeItem, { className: 'child-item', key: i, nodeId: `${i}`, onLabelClick: (e) => {
                if (e.target.tagName !== "INPUT") {
                    e.target = e.target.parentNode.parentNode.querySelector('input');
                    e.target.checked = !e.target.checked;
                }
                handleChangeEvent(e, filterType, updatedFilter, selected);
            }, label: item, classes: {
                content: classes.content
            } });
    });
    return (react_1.default.createElement("div", { className: 'checkbox-list' },
        react_1.default.createElement(lab_1.TreeView, null, List)));
};
exports.default = styles_2.withStyles(styles_1.default)(CheckboxList);
